import { Component, createRef } from 'react';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { isIOS, isIOS13 } from 'react-device-detect';
import isEqual from 'lodash-es/isEqual';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';

import withComponentName from '../../../../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class CompanyTags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasSeeMore: false,
      isSeeMore: false,
    };
    autoBind(this);
    this.tagsRef = createRef();
  }

  componentDidMount() {
    window.addEventListener('load', this.handleLoadEvent, { passive: true });
    window.addEventListener('resize', this.handleLoadEvent, { passive: true });
    this.handleLoadEvent();
  }

  componentDidUpdate(prevProps) {
    const { companyLists } = this.props;
    if (!isEqual(prevProps.companyLists, companyLists)) {
      this.handleLoadEvent();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.handleLoadEvent);
    window.removeEventListener('resize', this.handleLoadEvent);
  }

  handleLoadEvent() {
    const { offsetHeight } = this.tagsRef.current || {};
    const hasSeeMore = offsetHeight > 115;
    this.setState(({ isSeeMore }) => ({
      hasSeeMore,
      isSeeMore: hasSeeMore ? isSeeMore : false,
    }));
  }

  handleSeeMore() {
    this.setState(({ isSeeMore }) => ({
      isSeeMore: !isSeeMore,
    }));
  }

  render() {
    const { isSeeMore, hasSeeMore } = this.state;
    const {
      companyLists, selectedCompany, handleCompanyChange, isIR,
    } = this.props;
    const { id } = selectedCompany || {};

    return (
      <div className={cx('company_tags', { see_more: isSeeMore, ir: isIR })}>
        <div className={Styles.company_tags_modal}>
          {isSeeMore && (
            <div className={Styles.see_more_close} onClick={this.handleSeeMore}>
              <FontAwesomeIcon icon={faXmark} />
            </div>
          )}
          <div className={cx('tags_holder', { ios: isIOS || isIOS13, ir: isIR })} ref={this.tagsRef}>
            {companyLists.map((data) => (
              <NameTag
                key={data.id}
                data={data}
                selectedId={id}
                handleCompanyChange={handleCompanyChange}
                isIR={isIR}
              />
            ))}
          </div>
          {!isSeeMore && hasSeeMore && (
            <div className={cx('see_all_btn', { ir: isIR })}>
              <div className={cx('see_all', { ir: isIR })} onClick={this.handleSeeMore}>
                See All
                <FontAwesomeIcon icon={faChevronRight} />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const NameTag = ({
  selectedId, data, handleCompanyChange, isIR,
}) => {
  const { id, topicName } = data;
  const handleClick = () => {
    handleCompanyChange(data);
  };

  return (
    <div
      className={cx('name_tag', { ir: isIR }, { active: selectedId === id })}
      onClick={handleClick}
    >
      {topicName}
    </div>
  );
};

export default withComponentName(CompanyTags);
